import StarIcon from 'icons/Star.icon';
import {
  BuyerCountKeys,
  FilterOptionType,
} from 'router/subrouters/Dash/subrouters/private/subrouters/Portfolio/components/PortfolioFilterBar/models';

const EXCLUDE_WITHDRAWN_AND_PRIVATE_VIEWERS =
  '"withdrawnInterest": false, "isPrivateViewer": false, "isRequestedPrivateViewer": false';

export const BUYING_ALL_LISTINGS_QUERY = `[{${EXCLUDE_WITHDRAWN_AND_PRIVATE_VIEWERS}}]`;

const ENQUIRE_LISTINGS_QUERY = `[{${EXCLUDE_WITHDRAWN_AND_PRIVATE_VIEWERS}, "buyerStep": "enquire"}]`;

const ACCEEPT_LISTING_QUERY = `[{${EXCLUDE_WITHDRAWN_AND_PRIVATE_VIEWERS}, "buyerStep": "accept"}]`;

const CONFIRM_LISTING_QUERY = `[{${EXCLUDE_WITHDRAWN_AND_PRIVATE_VIEWERS}, "buyerStep": "confirm"}]`;

const OFFER_LISTING_QUERY = `[{${EXCLUDE_WITHDRAWN_AND_PRIVATE_VIEWERS}, "buyerStep": "offer"}]`;

const WITHDRAWN_LISTING_QUERY =
  '[{"withdrawnInterest": true, "isPrivateViewer": false, "isRequestedPrivateViewer": false}]';

export const buyerFilterOptions: FilterOptionType[] = [
  {
    label: 'all',
    value: BUYING_ALL_LISTINGS_QUERY,
  },
  {
    label: 'enquiry',
    value: ENQUIRE_LISTINGS_QUERY,
  },
  {
    label: 'accepted',
    value: ACCEEPT_LISTING_QUERY,
  },
  {
    label: 'prospect',
    value: CONFIRM_LISTING_QUERY,
  },
  {
    label: 'bidder',
    value: OFFER_LISTING_QUERY,
  },
  {
    label: 'withdrawn',
    value: WITHDRAWN_LISTING_QUERY,
  },
];

export const COUNT_VALUES_MAP: Record<string, BuyerCountKeys> = {
  [BUYING_ALL_LISTINGS_QUERY]: 'all',
  [ENQUIRE_LISTINGS_QUERY]: 'totalEnquiredListings',
  [ACCEEPT_LISTING_QUERY]: 'totalAcceptedListings',
  [CONFIRM_LISTING_QUERY]: 'totalConfirmedListings',
  [OFFER_LISTING_QUERY]: 'totalOfferedListings',
  [WITHDRAWN_LISTING_QUERY]: 'totalWithdrawnListings',
} as const;

export const MORE_ACTIONS = [
  {
    to: 'watchlist',
    label: 'shortlist',
    icon: StarIcon,
  },
];
